import styled from 'styled-components'

export const Wrapper = styled.div`
  > div {
    color: #757575;
    font-size: 14px;
    font-weight: 700;
    padding: 8px 0 4px;
  }
`
